"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardNumber = void 0;
var vue_1 = require("vue");
var PreferencesManager_1 = require("../PreferencesManager");
exports.CardNumber = vue_1.default.component('CardNumber', {
    props: {
        number: {
            type: String,
            required: true,
        },
    },
    methods: {
        showCardNumber: function () {
            return PreferencesManager_1.PreferencesManager.load('show_card_number') === '1';
        },
    },
    template: "\n        <div class=\"card-nr-outer\"><span class=\"card-nr-inner\" v-if=\"showCardNumber()\">{{ number }}</span></div>\n    ",
});
//# sourceMappingURL=CardNumber.js.map